import React from "react";
import classNames from "classnames";
import useTranslate from "../../../../modules/local/useTranslate";
import {useToggle} from "react-use";
import {BsCaretDownFill, BsCaretUpFill} from "react-icons/bs";

export const WrapperBlockSider = ({
    icon,
    title,
    children,
    titleColor = 'text-gray-800',
    expanded = false,
    borderTop, borderRight, borderBottom, borderLeft,
}) => {

    const t = useTranslate()
    const [isToggle, toggle] = useToggle()

    return !!children && (
        <div
            style={{
                boxShadow: '0 -2px 6px -2px rgba(0, 0, 0, 0.08), 0 8px 12px -4px rgba(0, 0, 0, 0.1)',
                borderTop: borderTop && '3px solid var(--color-secondary-500)',
                borderRight: borderRight && '3px solid var(--color-secondary-500)',
                borderBottom: borderBottom && '3px solid var(--color-secondary-500)',
                borderLeft: borderLeft && '3px solid var(--color-secondary-500)',
            }}
            className="p-3 flex flex-col background rounded-xl">
            <h3 className="mb-3 flex items-center gap-2">
                {icon}
                <span
                    className={classNames("flex-1 text-base font-bold uppercase leading-snug tracking-wide", titleColor)}>
                    {t(title)}
                </span>
                {expanded === true && (
                    isToggle ? <BsCaretUpFill onClick={() => toggle()} size={14} className="text-primary"/> :
                        <BsCaretDownFill onClick={() => toggle()} size={14} className={titleColor}/>
                )}
            </h3>
            {expanded === true ? (isToggle && children) : children}
        </div>
    )
}
